import React, {useState} from 'react';
import Input from "./Fields/Input";
import ArrowWhite from "../Shared/icons/ArrowWhite";
import PropTypes from "prop-types";
import {Form, Formik} from "formik";
import axios from "axios";
import Dropzone from "./Fields/Dropzone";
import * as Yup from 'yup';

const formTypes = {
    Default: "default",
    Alt: "alt",
};

function JobOpportunity(props) {
    const buttonText = props.buttonText;
    const formType = props.formType;
    const uploadsText = props.uploadsText;
    const action = props.action;
    const jobOpportunity = props.jobOpportunityTitle;
    const mailTemplate = props.mailTemplate;
    const errorMessages = JSON.parse(props.errorMessages);

    const successMessage = props.successMessage;
    const [showMessage, setShowMessage] = useState(false);

    const closePopup = (e) => {
        const popup = e.target.parentNode;
        const body = document.getElementsByTagName('body')[0];

        if (popup.classList.contains('is-active')) {
            popup.classList.remove('is-active');
        }

        if (body.classList.contains('is-locked')) {
            body.classList.remove('is-locked');
        }
    };

    return (
        <div>
            {showMessage && successMessage &&
                <div className="login-popup is-active">
                    <div className="login-popup__underlay" onClick={closePopup}></div>
                    <div className="login-popup__holder">

                        <div className="card z-1">
                            <div className="card-body p-0 ">
                                <div className="login-tile">
                                    <div className="login-tile-body login-tile-body--alt py-12">
                                        <div dangerouslySetInnerHTML={{__html: successMessage}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            }

            <Formik
                initialValues={{
                    vacature: jobOpportunity,
                    mail_template: mailTemplate,
                    firstname: "",
                    lastname: "",
                    phone: "",
                    email: "",
                    files: [],
                }}
                validateOnBlur={true}
                validateOnChange={false}
                validationSchema={Yup.object({
                    firstname: Yup.string().required(),
                    lastname: Yup.string().required(),
                    phone: Yup.string().required().matches(
                        /^((\+|00)?31|0)[\s.-]?[1-9]([\s.-]?[0-9]){8}$/,
                        errorMessages.phone.type
                    ),
                    email: Yup.string().email(errorMessages.email.type).required(),
                    files: formType === formTypes.Default ? Yup.array().required().min(1) : null
                })}
                onSubmit={(values, actions) => {
                    var formData = new FormData();

                    for (const property in values) {
                        if (property !== 'files') {
                            formData.set(property, values[property]);
                        }
                    }

                    for (let i = 0; i < values.files.length; i++) {
                        formData.append(`files[${i}]`, values.files[i]);
                    }

                    axios.post(action, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(res => {
                        if (res.data.success) {
                            setShowMessage(true);
                        } else {
                            setShowMessage(false);
                        }
                    });
                }}
            >
                {({errors, touched, validateField, validateForm, values, setFieldValue}) => (
                    <Form>
                        <Input
                            name="firstname"
                            placeholder="Voornaam"
                            required={true}
                            errors={errors.firstname}
                        />

                        <Input
                            name="lastname"
                            placeholder="Achternaam"
                            required={true}
                            errors={errors.lastname}
                        />

                        <Input
                            name="phone"
                            placeholder="Telefoonnummer"
                            required={true}
                            errors={errors.phone}
                        />

                        <Input
                            name="email"
                            placeholder="E-mail"
                            required={true}
                            errors={errors.email}
                        />

                        <div className="row align-items-end">
                            <div className="col-12 col-md">
                                <input type="hidden" name="form_type" value={formType}/>

                                {formType === formTypes.Default &&
                                    <Dropzone
                                        name="job_files"
                                        setFieldValue={setFieldValue}
                                        text={uploadsText}
                                        buttonText="Upload CV"
                                        removeText="Verwijderen"
                                        errors={errors.files ? 1 : 0}
                                    />
                                }
                            </div>

                            <div className="col-12 col-md-auto text-md-right">
                                {buttonText &&
                                    <div className="mt-8">
                                        <button type="submit"
                                                className="w-auto btn btn-primary justify-content-between d-inline-flex">
                                            <span className="">{buttonText}</span>

                                            <div className="btn-arrow">
                                                <ArrowWhite/>
                                            </div>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default JobOpportunity;

JobOpportunity.propTypes = {
    type: PropTypes.oneOf(Object.values(formTypes)),
    errorMessages: PropTypes.string
};

JobOpportunity.defaultProps = {
    type: formTypes.Default
}